/* @flow */
import BlockedUser from 'entities/BlockedUser';
import BlockedUsers from 'collections/BlockedUsers';
import BlockedUsersListItem from './BlockedUsersListItem';
import PropTypes from 'prop-types';
import * as React from 'react';
import Table from 'components/Table';

export default class BlockedUsersList extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    blockedUsers: PropTypes.instanceOf(BlockedUsers).isRequired,
  };

  renderBlockedUser(blockedUser: BlockedUser) {
    return <BlockedUsersListItem blockedUser={blockedUser} key={blockedUser.id} />;
  }

  renderBlockedUserList() {
    if (this.props.blockedUsers.length > 0) {
      return this.props.blockedUsers.map(this.renderBlockedUser);
    } else {
      return null;
    }
  }

  render() {
    if (this.props.blockedUsers.length <= 0) {
      return <p className="BlockedUsersList-empty">You have no blocked users.</p>;
    }

    return (
      <Table
        actionsColumn
        head={
          <tr>
            <th>Name</th>
            <th>Date blocked</th>
            <th />
          </tr>
        }
        className="BlockedUsersList">
        <tbody>{this.renderBlockedUserList()}</tbody>
      </Table>
    );
  }
}
